// @flow

export const messageFragment = {
  tag: 'textarea',
  name: 'message',
  label: 'forms.emailEnquire.placeholder.message',
};

export const companyFragment = {
  tag: 'input',
  type: 'text',
  name: 'company',
  label: 'forms.emailEnquire.placeholder.company',
};
